import { ArrowUpRightIcon, ShieldTickIcon } from '@newcore/icons';
import { ADMIN_CONSOLE_APP_NAME } from '@/common/constants';
import { buildAdminConsoleDashboardUrl } from '@/common/cross-app-urls';
import { useTenant } from '@/contexts/use-tenant';
import { useToast } from '@/hooks/use-toast';
import { useApplications } from '@/hooks/use-user-portal.queries';
import { TopNavItem } from './top-nav-item';

const LABEL = 'Admin console';

export function AdminConsoleButton() {
  const { tenant } = useTenant();
  const toast = useToast();
  const { data: applications } = useApplications();
  const hasAdminConsole = applications?.items.some(
    app => app.app_name === ADMIN_CONSOLE_APP_NAME
  );

  if (!hasAdminConsole) {
    return null;
  }

  const handleClick = () => {
    const opened = window.open(buildAdminConsoleDashboardUrl(tenant), '_blank');

    if (!opened) {
      toast.error({
        title: 'Launch blocked',
        message:
          'Your browser blocked the admin console window. Allow pop-ups for this site and try again.',
      });

      return;
    }

    opened.opener = null;
  };

  return (
    <TopNavItem
      label={LABEL}
      icon={ShieldTickIcon}
      trailingIcon={ArrowUpRightIcon}
      onClick={handleClick}
    />
  );
}
